export default __webpack_public_path__ + "static/media/yesodot-logo.5df47cc9.png";